export default {
  API_ENDPOINT: 'https://hidden-plateau-58997.herokuapp.com/api',
  TOKEN_KEY: '960f52b8-cd60-4fdb-8d93-30cdd2b3c32f',
}
